/**
 * Multivariate Zoning actions — namespaced Vuex actions.
 * Migrated from the standalone efficient-vineyard-multivariate plugin.
 *  - `post`           Storage upload + Firestore datasets/{id} doc.
 *                     Replaces the legacy api.efficientvineyard.com
 *                     /post/geojson endpoint.
 *  - `processKmeans`  k-means clustering of the joined vectors via
 *                     node-kmeans, preserved verbatim.
 */
import firebase from 'firebase/compat/app'
import { deriveHeaders } from '@/lib/deriveHeaders'
const fb = require('@/firebaseConfig.js')
const kmeans = require('node-kmeans')

export default {
  async post ({ commit, state, rootState }) {
    commit('setStateProperty', { property: 'posting', value: true })
    try {
      const farmId = (rootState.farm && rootState.farm.id) || state.farmId
      const path = `datasets/${farmId}/kmeans-${Date.now()}.geojson`
      await firebase.storage().ref(path).putString(
        JSON.stringify(state.clusteredGeoJson), 'raw',
        {
          contentType: 'application/json',
          // usageFinalize attributes bytes by customMetadata.userId —
          // without it, plugin-generated datasets aren't counted.
          customMetadata: { userId: (firebase.auth().currentUser && firebase.auth().currentUser.uid) || '' }
        }
      )
      const feats = (state.clusteredGeoJson && state.clusteredGeoJson.features) || []
      const headers = deriveHeaders({ features: feats })
      const uid = rootState.currentUser && rootState.currentUser.uid
      await fb.datasetsCollection.add({
        name: state.post.name,
        description: 'K-means zones (Multivariate Zoning).',
        headers: headers,
        farmId: farmId,
        createdOn: new Date(),
        createdBy: uid,
        updatedOn: new Date(),
        updatedBy: uid,
        file: { geoJsonPath: path, path: path, originalFileName: 'kmeans.geojson' },
        folderId: (state.folder && state.folder.id) || 'root',
        dynamic: false,
        vizSettings: {
          colorHeader: 'zone',
          colorBy: 'valueBased',
          zoneClassification: 'categorical'
        }
      })
      commit('setStateProperty', { property: 'posting', value: false })
      commit('setAlert', { active: true, message: 'This new dataset has been saved to your farm on Every.Farm!', level: 'alert-success', timeout: 4000 })
      commit('setStateProperty', { property: 'pickFolder', value: false })
    } catch (err) {
      console.log(err)
      commit('setStateProperty', { property: 'posting', value: false })
      commit('setAlert', { active: true, message: 'There was an issue saving your dataset to Every.Farm. Consider downloading directly and uploading manually.', level: 'alert-danger', timeout: 12000 })
    }
  },
  processKmeans ({ commit, state }) {
    commit('setStateProperty', { property: 'previewClusters', value: false })
    kmeans.clusterize(state.vectors, { k: state.zoneCount }, (err, res) => {
      if (err) {
        console.error(err)
      } else {
        const geoJsonObj = {
          type: 'FeatureCollection',
          features: []
        }
        // Loop clusters
        res.forEach((cluster, i) => {
          cluster.clusterInd.forEach(ind => {
            // Create a feature for this clustered point. Properties
            // are the joined-row values from state.allJsonDataArray.
            const featureObj = {
              type: 'Feature',
              properties: state.allJsonDataArray[ind],
              geometry: {
                coordinates: [],
                type: 'Point'
              }
            }
            featureObj.geometry.coordinates.push(state.allJsonDataArray[ind].longitude)
            featureObj.geometry.coordinates.push(state.allJsonDataArray[ind].latitude)
            delete featureObj.properties.longitude
            delete featureObj.properties.latitude
            featureObj.properties.cluster = i
            featureObj.properties.zone = i + 1
            geoJsonObj.features.push(featureObj)
          })
        })
        commit('setStateProperty', { property: 'clusteredGeoJson', value: geoJsonObj })
        commit('setStateProperty', { property: 'previewClusters', value: true })
      }
    })
  }
}
